import { navGroups } from '@platform/navigation';

/**
 * Порядок модулів у таблицях «Налаштувань» — як у верхньому меню й «Усіх модулях»: групи моделі навігації за порядком, модулі груп за
 * порядком у групі; модулі поза групами — наприкінці. Повертає ранг ключа модуля (менший — раніше).
 */
export function moduleRank(): (key: string) => number {
  const order = new Map<string, number>();
  for (const g of navGroups()) {
    for (const entry of [...g.modules, ...g.subgroups.flatMap((s) => s.modules)]) {
      const key = entry.split('/')[0]!;
      if (!order.has(key)) order.set(key, order.size);
    }
  }
  return (key: string) => order.get(key) ?? Number.MAX_SAFE_INTEGER;
}
